import { MockPersona } from "./mockPersonas.types";

export const noFace: MockPersona = {
  key: "noFace",
  name: "No-Face",
  description: "🇺🇸 | No name, address or phone | No policies | No HDC | No alerts",
  providerApiMockResponses: {
    cig: {
      billing: {
        fees: [],
        bills: [],
      },
      policies: {
        usa: [],
        canada: [],
      },
    },
    esign: {
      fetchESignDocuments: [],
      createESignRequest: "success",
    },
    insurance: {
      fetchEndorsement: [],
    },
    soul: {
      fetchSoul: {
        hagertyAccounts: {
          myHagertyAccount: {
            id: "1",
            loginEmail: "no@face.com",
            firstName: "",
            middleName: "",
            lastName: "",
            mailingAddress: {
              line1: "",
              line2: "",
              city: "",
              state: "",
              postalCode: "",
              country: "USA",
            },
            preferredPhone: "",
            salesforceAccounts: [
              {
                accountNumber: "123",
                id: "1",
                partnerId: null,
              },
            ],
            drivetrainAccounts: [
              {
                customerAccountLegacyKey: "000031",
                source: "USA",
                customerSourceSystemKey: "123",
                id: "1",
                partnerCustomerId: "123",
                partnerId: "UNKNOWN",
              },
            ],
            identityAccounts: [],
            message: undefined,
          },
        },
      },
    },
    member: {
      fetchMember: undefined,
    },
    billing: {
      fetchBilling: {
        bills: {
          bills: [],
          outstandingBalance: 0,
        },
      },
    },
    payments: {
      fetchPayEndorsementUrl: undefined,
    },
  },
};
